export default __webpack_public_path__ + "static/media/rabbit-orange.01d19ae6.svg";